import {AboutPageProps, MetaTagsProps} from "@/types";
import {OG_PATH, WEBSITE_URL, BUSINESS_NAME} from "@/content";

export const metaTagsAbout : MetaTagsProps = {
    title: `${BUSINESS_NAME} - About Us`,
    description: `${BUSINESS_NAME} are Sydney’s specialists in concrete formwork, excavation, steelfixing, and structural construction. Learn more about our expertise, mission, and trusted reputation in the building industry.`,
    keywords: "formwork company Sydney, concreting Sydney, excavation Sydney, about Innovative Construct Group, Sydney construction services, structural contractors Sydney",
    url: `${WEBSITE_URL}/about`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const aboutPageContent : AboutPageProps = {
    title: `About Us | ${BUSINESS_NAME}`,
    description: `${BUSINESS_NAME} is a trusted Sydney-based formwork and construction company delivering high-quality concreting, excavation, and structural solutions for residential, commercial, and civil projects. With years of industry expertise, our mission is to provide precision workmanship, safety-driven practices, and reliable project delivery to builders and developers across New South Wales.`,
    images: [],
}
